import { atom } from "recoil";

export type OptionModalType = {
  visibleConfirm: boolean;
  handleConfirm?: any;
  title: string;
  modalData: any;
};

export const optionModalState = atom<OptionModalType>({
  key: "optionModal",
  default: {
    visibleConfirm: false,
    title: "",
    modalData: [],
  },
});
